<mat-toolbar
    color="primary"
    role="toolbar"
    attr.aria-label="{{ 'shared.skeleton.toolbar.label' | translate }}"
    attr.aria-description="{{
        'shared.skeleton.toolbar.description' | translate
    }}">
    <mat-toolbar-row
        [style.paddingInline]="(breakpointSm$ | async) ? '4px' : '16px'">
        <ng-content select="[sidenavButton]" />
        @if (showUserOrCaseName) {
            <span class="ms-2 min-w-0 text-ellipsis overflow-hidden">
                @switch (zone) {
                    @case (PlatformZones.ADMIN_ZONE) {
                        @if (caseName) {
                            <span
                                [matTooltip]="caseName.translations[currLang]"
                                matTooltipPositionAtOrigin>
                                <apcam-translation [model]="caseName" />
                            </span>
                        }
                    }
                    @case (PlatformZones.CLIENT_ZONE) {
                        <span
                            [matTooltip]="currentUser.name ?? ''"
                            matTooltipPositionAtOrigin>
                            {{ currentUser.name }}
                        </span>
                    }
                }
            </span>
        }
        <div
            class="ms-auto flex justify-end items-center"
            [style.gap]="(breakpointSm$ | async) ? '4px' : '8px'">
            <ng-content select="[toggleDarkMode]" />
            <apcam-notifications-badge
                [notificationCount]="notificationCount()"
                (dialogOpen)="openNotificationDialog.emit()" />
            <apcam-language-selection
                [availableLanguages]="availableLanguages" />
            <apcam-profile-detail [currentUser]="currentUser" />
            <!-- Logout -->
            <span>
                <button
                    mat-icon-button
                    attr.aria-label="{{ 'shared.navbar.logout' | translate }}"
                    (click)="logout()">
                    <mat-icon>logout</mat-icon>
                </button>
            </span>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
